import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin"; // Подключаем плагин ScrollTo
import SplitText from 'gsap/SplitText'
import { mapActions, mapState } from 'pinia'
import { getSmoother } from 'utils/ScrollSmootherInstance.js';
import matchMediaConfig from 'utils/matchMedia.js'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);
gsap.registerEase("easeInOutCubic", [0.42, 0, 0.21, 0.99]);
gsap.registerEase("smoother", [0.42, 0, 0.58, 1]);
import { useScrollStore } from "stores/scroll";
export default {
	data() {
		return {
			blockText: null,
			blockTitle: null,
			splitText: null,
			splitTitle: null,
			hasAnimatedText: false,
			hasAnimatedTitle: false
		}
	},
	methods: {
		...mapActions(usePageAnimationStore, ["setPageEnableScroll"]),
		animateText() {
			if (this.hasAnimatedText) return;

			if (this.splitText) {
				this.splitText.revert();
			}
			gsap.set(this.blockText, { opacity: 1 });

			this.splitText = new SplitText(this.blockText, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitText.lines, {
				duration: 0.8,
				yPercent: 200,
				opacity: 0,
				stagger: 0.1,
				ease: "easeInOutCubic",
				onComplete: () => {
					this.hasAnimatedText = true;
				}
			})
		},
		animateTitle() {
			if (this.hasAnimatedTitle) return;

			if (this.splitTitle) {
				this.splitTitle.revert();
			}
			gsap.set(this.blockTitle, { opacity: 1 });

			this.splitTitle = new SplitText(this.blockTitle, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitTitle.lines, {
				duration: 0.8,
				yPercent: 100,
				opacity: 0,
				stagger: 0.1,
				ease: "easeInOutCubic",
				onComplete: () => {
					this.hasAnimatedTitle = true;
				}
			})
		},
		initAnimations() {
			const mm = gsap.matchMedia()
			mm.add(matchMediaConfig, (context) => {
				const { isDesktop, isMobile } = context.conditions
				// 1. Добавляем timeline через context.add
				context.add(() => {
					const headerHeight = document.querySelector('header').offsetHeight;
					this.blockTitle = document.querySelector(this.element + ' .railways__title');
					this.blockText = document.querySelector(this.element + ' .railways__text');
					const cards = document.querySelectorAll(this.element + ' .railways__item');
					const smoother = getSmoother();

					gsap.set(cards, { y: 100 });


					if (isDesktop) {
						gsap.to(this.previousBlock, {
							opacity: 0,
							duration: 1.6,
							scrollTrigger: {
								trigger: this.element,
								start: "top 70%",
								end: "top top",
								scrub: true
							}
						});

						// Анимируем заголовок при входе в секцию
						ScrollTrigger.create({
							trigger: this.element,
							start: "top bottom",
							onEnter: () => {
								this.animateTitle();
							}
						});

						// Создаем отдельный триггер для каждой карточки
						cards.forEach((card, index) => {
							ScrollTrigger.create({
								trigger: card,
								start: "top-=130 bottom",
								onEnter: () => {
									gsap.to(card, {
										y: 0,
										duration: 1,
										ease: "easeInOutCubic",
										delay: index * 0.1,
										onComplete: () => {
											if (index === cards.length - 1) {
												this.animateText();
											}
										}
									});
								},
								onLeaveBack: () => {
									gsap.killTweensOf(card);
									gsap.set(card, { y: 100 });
								}
							});
						});

						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вниз
							ScrollTrigger.create({
								trigger: this.element,
								start: `bottom ${headerHeight}px`,
								// start: this.scrollUpPosition,
								id: "cards-1-" + this.element,
								markers: false,
								end: `top ${headerHeight}px`,
								onLeaveBack: () => {
									if (this.getScrollDirection === 'up') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(this.element, `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							})
						}

						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вниз
							ScrollTrigger.create({
								trigger: this.element,
								start: "center 60%",
								// start: this.scrollUpPosition,
								end: "top bottom",
								id: "cards-2-" + this.element,
								markers: false,
								onLeaveBack: () => {
									if (this.getScrollDirection === 'up') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(this.element, `top bottom`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});

									}
								},
							})
						}

						//TODO ANIMATION
						if (this.getScrollEnabled && true) {
							// настройки для автоматического скролла блока вверх
							ScrollTrigger.create({
								trigger: this.element,
								start: "25% bottom",
								// start: this.scrollDownPosition,
								end: `bottom bottom`,
								id: "cards-3",
								markers: false,
								onEnter: () => {
									if (this.getScrollDirection === 'down') {
										gsap.to(smoother, {
											scrollTop: Math.min(
												ScrollTrigger.maxScroll(window),
												smoother.offset(this.element, `top ${headerHeight}px`)
											),
											duration: 1.2,
											ease: "smoother",
											onStart: () => {
												smoother.smooth(0.1);
												smoother.paused(true)
											},
											onComplete: () => {
												smoother.paused(false)
												smoother.smooth(3);
											}
										});
									}
								},
							});
						}

						gsap.to(this.element, {
							duration: 1.6,
							opacity: 0,
							ease: "easeInOutCubic",
							scrollTrigger: {
								trigger: this.element,
								start: "top top",
								end: "bottom top",
								scrub: true
							}
						});
					}


					if (isMobile) {
						gsap.to(this.previousBlock, {
							opacity: 0,
							duration: 1.6,
							scrollTrigger: {
								trigger: this.element,
								start: "top 30%",
								end: "top top",
								scrub: true
							}
						});

						// Анимируем заголовок при входе в секцию
						ScrollTrigger.create({
							trigger: this.element,
							start: "top bottom",
							onEnter: () => {
								this.animateTitle();
								setTimeout(() => {
									this.animateText();
								}, 100);
							}
						});

						// Создаем отдельный триггер для каждой карточки
						cards.forEach((card, index) => {
							ScrollTrigger.create({
								trigger: card,
								start: "top-=130 bottom",
								onEnter: () => {
									gsap.to(card, {
										y: 0,
										duration: 0.3,
										ease: "easeInOutCubic",
										delay: index * 0.05, // Задержка между карточками 0.1 сек
									});
								},
								onLeaveBack: () => {
									gsap.killTweensOf(card);
									gsap.set(card, { y: 100 });
								}
							});
						});

						gsap.to(this.element, {
							duration: 1.6,
							opacity: 0,
							ease: "easeInOutCubic",
							scrollTrigger: {
								trigger: this.element,
								start: "bottom 30%",
								end: "bottom top",
								scrub: true
							}
						});


						//TODO ANIMATION
						// if (this.getScrollEnabled && true) {
						// 	// настройки для автоматического скролла блока вверх
						// 	ScrollTrigger.create({
						// 		trigger: this.element,
						// 		start: "25% bottom",
						// 		// start: this.scrollDownPosition,
						// 		end: `bottom bottom`,
						// 		id: "cards-3",
						// 		markers: false,
						// 		onEnter: () => {
						// 			if (this.getScrollDirection === 'down') {

						// 				gsap.to(smoother, {
						// 					scrollTop: Math.min(
						// 						ScrollTrigger.maxScroll(window),
						// 						smoother.offset(this.element, `top ${headerHeight}px`)
						// 					),
						// 					duration: 1.2,
						// 					ease: "smoother",
						// 					onStart: () => {
						// 						smoother.smooth(0.1);
						// 						smoother.paused(true)
						// 					},
						// 					onComplete: () => {
						// 						smoother.paused(false)
						// 						smoother.smooth(3);
						// 					}
						// 				});
						// 			}
						// 		},
						// 	});
						// }
					}
				})
			})
		},
		killAnimations() {
			if (this.splitText) {
				this.splitText.revert();
			}
			gsap.set(this.blockText, { opacity: 1 });

			this.splitText = new SplitText(this.blockText, {
				type: "lines",
				linesClass: "line",
				autoSplit: true,
			})
			gsap.from(this.splitText.lines, {
				duration: 1.2,
				yPercent: 100,
				opacity: 0,
				stagger: 0.2,
				ease: "easeInOutCubic",
				onComplete: () => {
					this.hasAnimatedText = true;
				}
			})
		},
	},
	computed: {
		...mapState(useViewportStore, ["getIsMobileState"]),
		...mapState(usePageAnimationStore, ["getPageCanAnimateBlocks", "getScrollDirection"]),
		...mapState(useScrollStore, ["getScrollEnabled", "scrollUpPosition", "scrollDownPosition"]),
	},
	mounted() {
		this.$nextTick(() => {
			if (this.getPageCanAnimateBlocks) {
				this.initAnimations();
			}
		});
	},
	beforeUnmount() {
		this.killAnimations();
	},
	watch: {
		getPageCanAnimateBlocks(state) {
			if (state) {
				this.initAnimations();
			}
		},
	}
}
